import React from "react"

function LoadingAnimation() {
  return (
    <div className="loading-animation">
      <div className="loading-animation--top" />
      <div className="loading-animation--bottom" />
    </div>
  )
}

export default LoadingAnimation
